<template>
  <div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="controlDialog"
      :width="dialogW || '500px'"
      v-dialogDrag
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :before-close="closeDialog"
      :append-to-body="true"
    >
      <el-form
        :rules="rules"
        class="dialogForm"
        ref="dialogForm"
        :model="formDialog"
      >
        <!-- <el-form-item label="车牌号" prop="" v-if="alarmData.plateNo">
          <el-input
            disabled
            :placeholder="alarmData && alarmData.plateNo"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="名称" prop="">
          <el-input
            disabled
            :placeholder="alarmData && alarmData.deviceName"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="编号"
          prop=""
          v-if="alarmData && alarmData.alarmType != '80103'"
        >
          <el-input
            disabled
            :placeholder="
              (alarmData && alarmData.thirdAlarmDevId) ||
              (alarmData && alarmData.thirdDeviceId)
            "
          ></el-input>
        </el-form-item>
        <el-form-item
          label="车牌号码"
          prop="plateNo"
          v-if="alarmData && alarmData.alarmType == '80103'"
        >
          <el-input
            disabled
            :placeholder="alarmData && alarmData.plateNo"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="'抑制周期-' + (timeType == 1 ? '秒/s' : '分钟/m')"
          prop="num"
        >
          <el-input
            placeholder="请输入抑制周期时间"
            v-model="formDialog.num"
            clearable
            class="input-with-select"
          >
            <el-select
              v-model="timeType"
              slot="append"
              style="width: 150px"
              placeholder="请选择"
            >
              <el-option label="秒/s" value="1"></el-option>
              <el-option label="分钟/m" value="2"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item label="抑制时间范围" prop="ignoreTime">
          <el-date-picker
            v-model="formDialog.ignoreTime"
            type="datetimerange"
            style="width: 100%"
            placeholder="选择时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog" :loading="sbmitLoading">取消</el-button>
        <el-button
          type="primary"
          :loading="sbmitLoading"
          @click="controlSubmit"
          >{{ sbmitLoading ? "提交中" : "确定" }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { api } from "../api";

export default {
  data() {
    return {
      sbmitLoading: false,
      dialogW: "500px",
      timeType: "1",
      rules: {
        // ignoreTime: [
        //   { required: true, message: "请选择时间范围", trigger: "change" },
        // ],
        num: [
          {
            required: false,
            pattern: /^[1-9]\d*$/,
            message: "请输入大于0的正整数",
            trigger: "blur",
          },
        ],
      },
      dialogTitle: "告警抑制",
      controlDialog: false,
      alarmData: null,
      formDialog: {
        ignoreTime: [],
        num: "",
      },
      alarmType: "",
    };
  },
  methods: {
    closeDialog() {
      this.timeType = "1";
      this.controlDialog = false;
      // this.alarmData = null
      this.sbmitLoading = false;
      this.$refs.dialogForm.resetFields();
    },
    controlSubmit() {
      if (!this.formDialog.ignoreTime && !this.formDialog.num) {
        this.$message.error("请填写抑制周期或选择时间范围后提交数据");
        return;
      }
      this.$refs.dialogForm.validate((vaild) => {
        if (vaild) {
          let params = {
            alarmDevId: this.alarmData.alarmDevId,
            alarmType: this.alarmData.alarmType,
            subSystem: this.alarmData.subSystem,
            deviceName: this.alarmData.deviceName,
            plateNo: this.alarmData.plateNo,
            // ignoreTime: this.formDialog.ignoreTime,
            alarmInterval:
              this.timeType == 1
                ? this.formDialog.num
                : this.timeType == 2
                ? this.formDialog.num * 60
                : this.formDialog.num * 3600,
            beginTime: this.formDialog.ignoreTime[0],
            endTime: this.formDialog.ignoreTime[1],
          };
          this.sbmitLoading = true;
          this.$fetch(api.cms.addAlarmIgnoreConfig, params).then((res) => {
            this.sbmitLoading = false;
            if (res.success) {
              this.$emit("alarmControl");
              this.controlDialog = false;
              this.$message.success(res.msgContent);
            } else {
              this.$message.error(res.msgContent);
            }
          });
        }
      });
    },
  },
};
</script>